import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "checked", "disabled"];
import clsx from 'clsx';
import { SpriteIcons } from '@/user/components/common/';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Checkbox',
    props: {
        id: {},
        label: {},
        checked: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        className: { default: '' }
    },
    emits: ["update:checked", "change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const checkboxStyle = {
            container: 'group relative flex h-fit items-center gap-8',
            input: 'peer sr-only absolute',
            defaultCheckbox: 'rounded-2 peer-disabled:bg-gray-250 min-h-16 min-w-16 border-1 border-gray-200 bg-white peer-checked:hidden peer-disabled:border-gray-300',
            checkedIcon: 'pointer-events-none hidden h-16 max-h-16 w-16 min-w-16 peer-checked:block',
            labelText: 'text-body-5 min-w-39 break-keep break-words text-gray-800 group-hover:text-blue-700 peer-checked:font-semibold peer-checked:text-blue-700 peer-disabled:pointer-events-none peer-disabled:text-gray-400',
        };
        const { container, input, defaultCheckbox, checkedIcon, labelText } = checkboxStyle;
        const emit = __emit;
        const handleChange = (event) => {
            emit('change', event);
            emit('update:checked', event.target.checked);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(_unref(clsx)(_unref(container), props.className))
            }, [
                _createElementVNode("input", {
                    id: props.id,
                    checked: props.checked,
                    class: _normalizeClass(_unref(input)),
                    disabled: props.disabled,
                    type: "checkbox",
                    onChange: handleChange
                }, null, 42, _hoisted_1),
                _createElementVNode("span", {
                    "aria-hidden": "true",
                    class: _normalizeClass(_unref(defaultCheckbox))
                }, null, 2),
                _createVNode(_unref(SpriteIcons), {
                    "aria-hidden": "true",
                    class: _normalizeClass(_unref(checkedIcon)),
                    name: "checkbox-checked"
                }, null, 8, ["class"]),
                _createElementVNode("span", {
                    class: _normalizeClass(_unref(clsx)(_unref(labelText), 'desktop:min-w-45 desktop:text-body-4'))
                }, _toDisplayString(props.label), 3)
            ], 2));
        };
    }
});
